import { Link } from 'gatsby'
import React from 'react'
import fluxibleLogo from '../images/FluxibleHeaderLogo@2x.png'

const Logo = () => (
  <Link aria-label="Navigate to homepage" to="/"><img src={fluxibleLogo} alt="Fluxible Logo" /></Link>
)

export default Logo
